import { TournamentDataType } from "types/Tournament";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

interface ITournamentStore {
  tournament: TournamentDataType | null;
  tournaments: TournamentDataType[] | null;
  setTournament: (tournament: Nullable<TournamentDataType>) => void;
  setTournaments: (tournaments: TournamentDataType[]) => void;
}

export const useTournamentsStore = createWithEqualityFn<ITournamentStore>()(
  devtools(
    (set) => ({
      tournament: null,
      tournaments: null,
      setTournament: (tournament: Nullable<TournamentDataType>) => {
        set({ tournament });
      },
      setTournaments: (tournaments: TournamentDataType[]) => {
        set({ tournaments });
      },
    }),
    { name: "Tournament Store" },
  ),
  shallow,
);
